import { UrlSegment, UrlMatchResult } from '@angular/router';
import { environment } from '@env/environment';
import { AppComponent } from '@app/app.component';
import { SiteConfigService } from './core/services/siteconfig.service';

/**
 * OB-7718: id сайта (ru/by) для матчеров — БЕЗ обращения к DI напрямую.
 * Матчеры — статичные функции в общем route config, у них нет инжектора.
 * Прежний путь `AppComponent.injector.get(...)` на SSR гонялся между
 * конкурентными запросами: статик перезаписывался соседним рендером, и
 * матчер читал уже УНИЧТОЖЕННЫЙ инжектор → NG0205, падение рендера.
 * На сервере язык берётся из AsyncLocalStorage запроса (кладёт server.ts
 * в globalThis.__ovbReqLang) — корректен при любой конкуренции; в браузере
 * приложение одно, статик безопасен. Фолбэк 'ru' — на случай вызова вне
 * обоих контекстов (лучше дефолтный сайт, чем исключение в recognize).
 */
function currentSiteId(): string {
    const als: any = (globalThis as any).__ovbReqLang;
    const lang = als?.getStore?.();
    if (lang) {
        return lang;
    }
    try {
        return AppComponent.injector.get(SiteConfigService).id();
    } catch (e) {
        return 'ru';
    }
}

export function customPageMatcher(urls: UrlSegment[]) {
    let path = '';
    for (let url of urls) {
        if (url.path) {
            path += (path? '/' : '') + url.path;
        }
    }
    for (let pageUrl of environment['custom_pages']) {
        if (pageUrl === path) {
            return ({
                consumed: urls,
                posParams: {alias: new UrlSegment(path, {})}
            }) as UrlMatchResult;
        }
    }
    return null;
}

export function blogMatcher(urls: UrlSegment[]) {
    if (urls.length > 0) {
        const baseUrl = urls[0].path;
        if (baseUrl === 'posts') {
            return ({
                consumed: [urls[0]],
                posParams: {}
            }) as UrlMatchResult;
        }
    }
    return null;
}

export function getSubPostMatcher(mids: string[], addUrls: string[] = []) {
    return (origUrls: UrlSegment[]) => {
        if ((origUrls.length > 2) && (origUrls[0].path === 'promo') && (origUrls[1].path === 'overbetting') && origUrls[2].path.length) {
            return null;
        }
        const siteId = currentSiteId();
        if (origUrls.length > 0) {
            for (const mid of mids) {
                const posParams = {};
                const postCategoriesMap = {};
                for (const post_category of environment.post_categories) {
                    if (post_category.site_id && (post_category.site_id != siteId)) {
                        continue;
                    }
                    if (post_category.rendering_template !== mid) {
                        continue;
                    }
                    postCategoriesMap[post_category.direct_url] = post_category;
                }
                const urls = origUrls;
                let i = 0;
                let categoryAliasPath = '';
                while (i < urls.length) {
                    if (i === 0) {
                        categoryAliasPath = urls[i].path;
                    } else {
                        categoryAliasPath = categoryAliasPath + '/' + urls[i].path;
                    }
                    if (postCategoriesMap[categoryAliasPath]) {
                        const post_category = postCategoriesMap[categoryAliasPath];
                        posParams['categoryAlias'] = new UrlSegment(post_category['id'], {});
                        posParams['taxonomy_id'] = new UrlSegment(post_category['tx_id'], {});
                        let urlI = i;

                        let iId = urlI + 1;
                        let length = iId + 1;
                        let returnData = null;

                        if (addUrls.length > 0) {
                            if (!urls[iId] || (addUrls.indexOf(urls[iId].path) === -1) ) {
                                return null;
                            }
                        }

                        if ((urls.length === length + 1) && (urls[iId].path === 'draft')) {
                            iId = iId + 1;
                            length = length + 1;
                        }
                        if ((urls.length === length) && urls[iId].path.length) {
                            const id = +urls[iId].toString();
                            if (!isNaN(id) && (id > 0)) {
                                return ({
                                    consumed: origUrls.slice(0, urlI + 1),
                                    posParams: post_category.direct_url !== post_category.article_front_url? {'redirect': new UrlSegment('/' + post_category.article_front_url + '/' + id + '/', {})}:{}
                                }) as UrlMatchResult;
                            }
                        }

                        return ({
                            consumed: origUrls.slice(0, urlI + 1),
                            posParams: posParams
                        }) as UrlMatchResult;
                    }
                    i++;
                }
            }
        }
        return null;
    }
}

export function bookmakersPromoMatcher(urls: UrlSegment[]) {
    if ((urls.length >= 2) && (urls[0].path === 'bookmakers') && (urls[1].path === 'promo')) {
        return ({
            consumed: urls,
            posParams: {}
        }) as UrlMatchResult;
    }
    return null;
}

export function сontestRulesMatcher(urls: UrlSegment[]) {
    if ((urls.length >= 2) && (urls[0].path === 'tips') && (urls[1].path === environment['tips']['mainTemplateAlias'])) {
        return ({
            consumed: urls.slice(0, 2),
            posParams: {}
        }) as UrlMatchResult;
    }
    return null;
}

export function blogCreateMatcher(urls: UrlSegment[]) {
    const ln = urls.length;
    if (ln > 1) {
        if ((urls[ln - 1].path !== 'create') && (urls[ln - 2].path !== 'update')) {
            return null;
        }
        if (urls[0].path === 'posts') {
            return ({
                consumed: [urls[0]],
                posParams: {
                    directUrl: urls[0]
                }
            }) as UrlMatchResult;
        }
    }
    return null;
}

export function profile2IndexMatcher(urls: UrlSegment[]) {
    const idUser = urls[2]?.path.match(/^\d+$/);
    if (urls[0].path === 'user' && urls[1].path === 'profile') {
        if (!urls[2] || idUser) {
            return ({
                consumed: [urls[0],urls[1]],
                posParams: {}
            }) as UrlMatchResult;
        }
    }
    return null;
}
